import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useScrollAnimation from "../../hooks/UseScrollAnimation";
export default function ContactSection() {
    const { t } = useTranslation();
    useScrollAnimation();
    return (
        <section className="relative py-[40px] bg-[#017E89]">
            <div className="container flex flex-col gap-[15px] items-center text-center py-[20px]">
                <div className="flex flex-col items-center text-center">
                    <div className="js-scroll fade-top text-[30px] text-white capitalize font-bold">{t("Contact us Now")}</div>
                    <p className="w-100 js-scroll fade-btm w-[75%] text-white">
                        {t("Contact us Now text")}
                    </p>
                </div>
                <Link className="js-scroll fade-btm bg-white w-fit px-[30px] py-[7px] rounded-[4px] text-[#017E89] font-bold capitalize" to={"/contact"}>{t("Contact Now")}</Link>
            </div>
        </section>
    );
}